'use client';
import JumpLink from '@/components/JumpLink';
import CDNImage from '@/components/cdnImage/cdnImage';
import style from './style.module.scss';

//---------------引入swiper-----------------
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';
import { Home_Page_Code } from '@/constants/cms';
import { uaParse } from '@/intl-jdi-common-ssr/utils/uaParser';
import { imageUtil } from '@/utils/imageUtil';

export default function Module({
  moduleData,
  pageName,
  bannerType,
}: {
  moduleData: any;
  pageName: string;
  bannerType?: 'banner' | 'middlebanner';
}) {
  const PageConfig: any = {};

  const initConfig = (moduleData: any) => {
    PageConfig.data = moduleData.dataBatch?.config;
    PageConfig.Rotating = moduleData.dataStyle?.Rotating?.Rotating;
    PageConfig.isAd = moduleData.dataStyle?.Rotating?.isAd;
  };

  initConfig(moduleData);

  // 可以根据bannerType来进行不同的处理
  // console.log('uk-h5-banner-m bannerType:', bannerType);

  const getJumpUrl = (jumpParams: any) => {
    const jumpType = jumpParams?.jumpType;
    const jumpValue = jumpParams?.jumpValue;
    if (jumpType === 'page-code') {
      return `/cms/${jumpValue.pageCodeInfo?.pageCode}${uaParse().isInJoybuyApp ? '?hideTitle=true' : ''}`;
    }
    // -------------- JumpType: Url -------------------- //
    if (jumpType === 'custom') {
      return jumpValue.link;
    }
  };

  const isSingleImage = PageConfig.data.length === 1;

  return (
    <div className={style['uk-h5-banner-m']}>
      <Swiper
        slidesPerView={PageConfig.Rotating || PageConfig.data.length === 1 ? 1 : 1.1}
        spaceBetween={PageConfig.Rotating || PageConfig.data.length === 1 ? 0 : 10} // 单张图片时无间距，多张图片时10px间距
        loop={PageConfig.Rotating || PageConfig.data.length === 1 ? true : false}
        allowTouchMove={true}
        followFinger={true}
        pagination={{ clickable: true }}
        autoplay={
          PageConfig.Rotating
            ? {
                delay: 4000,
                disableOnInteraction: false,
              }
            : false
        }
        modules={PageConfig.Rotating ? [Pagination, Autoplay] : [Pagination]}
        className={`${style.mySwiper} ${isSingleImage ? style.singleImage : ''}`}
        style={{ borderRadius: PageConfig.Rotating ? '8px' : '0px' }} // 整个Swiper圆角 - 老逻辑
      >
        {PageConfig.data.map((carousel: any, index: any) => (
          <SwiperSlide key={index}>
            <JumpLink jumpParams={carousel?.jump}>
              <div
                className={style.slideItem}
                onClick={(e) => {
                  // 首页banner，区分top banner和middle banner
                  if (pageName === Home_Page_Code) {
                    spmTrackingUtils.spmClick({
                      spm:
                        bannerType === 'banner'
                          ? `a0145.b002218.c00002486.${index + 1}`
                          : `a0145.b002218.c00002594.${index + 1}`,
                      event_id:
                        bannerType === 'banner' ? 'Home_Banner' : 'Home_Advertisement_Banner',
                      target: e.target as HTMLElement,
                      page_id: 'Home_Main',
                      json_param: JSON.stringify({
                        url: getJumpUrl(carousel?.jump),
                      }),
                    });
                  } else {
                    // 小首页banner
                    spmTrackingUtils.spmClick({
                      spm: `a0145.b002244.c00002474.${index + 1}`,
                      page_id: 'Mini_Hp',
                      event_id: 'Home_Mini_Hp_Banner',
                      target: e.target as HTMLElement,
                      json_param: JSON.stringify({
                        index: index,
                        url: getJumpUrl(carousel?.jump),
                        Mini_Hp_Name: pageName,
                      }),
                    });
                  }
                }}
                data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
                data-exp={JSON.stringify(
                  pageName === Home_Page_Code
                    ? bannerType === 'banner'
                      ? {
                          spm: `a0145.b002218.c00002486.${index + 1}`, // 首页top banner曝光
                          event_id: 'Home_Banner_Expo',
                          page_id: 'Home_Main',
                          json_param: {
                            url: getJumpUrl(carousel?.jump),
                          },
                        }
                      : {
                          spm: `a0145.b002218.c00002594.${index + 1}`, // 首页middle banner曝光
                          event_id: 'Home_Advertisement_Banner',
                          page_id: 'Home_Main',
                          json_param: {
                            url: getJumpUrl(carousel?.jump),
                          },
                        }
                    : {
                        spm: `a0145.b002244.c00002474.${index + 1}`, // 小首页banner曝光
                        page_id: 'Mini_Hp',
                        event_id: 'Home_Mini_Hp_Banner_Expo',
                        json_param: {
                          index: index,
                          url: getJumpUrl(carousel?.jump),
                          Mini_Hp_Name: pageName,
                        },
                      },
                )}
              >
                <CDNImage
                  src={carousel?.image?.imageUrl && imageUtil.onlyKey(carousel?.image?.imageUrl)}
                  width={351}
                  height={212}
                  alt='banner Image'
                  priority={index < 3}
                  className={style.cateimg}
                />
              </div>
            </JumpLink>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
